"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mod = exports.log = exports.PI2 = exports.PHI = exports.Vec2 = exports.distributePointsInBuffer = exports.prepareBufferForInterpolation = exports.interpolate = exports.distanceFromRepetition = exports.angle2FromRepetition = exports.angleFromRepetition = exports.random = exports.noise = exports.now = exports.toRadians = exports.toDegrees = exports.relativeClamp = exports.clamp = exports.lerp = void 0;
/**
 * Types & Interface
 */
__exportStar(require("./types"), exports);
// Set glMatrixArrayType
const gl_matrix_1 = require("gl-matrix");
gl_matrix_1.glMatrix.setMatrixArrayType(Array);
/**
 * Core
 */
__exportStar(require("./Scene"), exports);
__exportStar(require("./SceneChild"), exports);
__exportStar(require("./Group"), exports);
// Shapes
__exportStar(require("./shapes/ShapeBase"), exports);
__exportStar(require("./shapes/ShapePrimitive"), exports);
__exportStar(require("./shapes/ShapeLoop"), exports);
__exportStar(require("./shapes/ShapeBuffer"), exports);
__exportStar(require("./shapes/Shape"), exports);
__exportStar(require("./shapes/ShapeRecursive"), exports);
__exportStar(require("./shapes/ShapeFollow"), exports);
__exportStar(require("./shapes/primitives/Line"), exports);
__exportStar(require("./shapes/primitives/Triangle"), exports);
__exportStar(require("./shapes/primitives/Rect"), exports);
__exportStar(require("./shapes/primitives/Polygon"), exports);
__exportStar(require("./shapes/primitives/Circle"), exports);
__exportStar(require("./shapes/primitives/Star"), exports);
__exportStar(require("./shapes/primitives/Rose"), exports);
__exportStar(require("./shapes/primitives/Spiral"), exports);
__exportStar(require("./shapes/primitives/Lissajous"), exports);
__exportStar(require("./shapes/primitives/SuperShape"), exports);
// Modifiers
__exportStar(require("./modifiers/Modifier"), exports);
__exportStar(require("./modifiers"), exports);
// Utilities
var Utilities_1 = require("./Utilities");
Object.defineProperty(exports, "lerp", { enumerable: true, get: function () { return Utilities_1.lerp; } });
Object.defineProperty(exports, "clamp", { enumerable: true, get: function () { return Utilities_1.clamp; } });
Object.defineProperty(exports, "relativeClamp", { enumerable: true, get: function () { return Utilities_1.relativeClamp; } });
Object.defineProperty(exports, "toDegrees", { enumerable: true, get: function () { return Utilities_1.toDegrees; } });
Object.defineProperty(exports, "toRadians", { enumerable: true, get: function () { return Utilities_1.toRadians; } });
Object.defineProperty(exports, "now", { enumerable: true, get: function () { return Utilities_1.now; } });
Object.defineProperty(exports, "noise", { enumerable: true, get: function () { return Utilities_1.noise; } });
Object.defineProperty(exports, "random", { enumerable: true, get: function () { return Utilities_1.random; } });
Object.defineProperty(exports, "angleFromRepetition", { enumerable: true, get: function () { return Utilities_1.angleFromRepetition; } });
Object.defineProperty(exports, "angle2FromRepetition", { enumerable: true, get: function () { return Utilities_1.angle2FromRepetition; } });
Object.defineProperty(exports, "distanceFromRepetition", { enumerable: true, get: function () { return Utilities_1.distanceFromRepetition; } });
Object.defineProperty(exports, "interpolate", { enumerable: true, get: function () { return Utilities_1.interpolate; } });
Object.defineProperty(exports, "prepareBufferForInterpolation", { enumerable: true, get: function () { return Utilities_1.prepareBufferForInterpolation; } });
Object.defineProperty(exports, "distributePointsInBuffer", { enumerable: true, get: function () { return Utilities_1.distributePointsInBuffer; } });
var Vec2_1 = require("./math/Vec2");
Object.defineProperty(exports, "Vec2", { enumerable: true, get: function () { return Vec2_1.default; } });
var math_1 = require("./math");
Object.defineProperty(exports, "PHI", { enumerable: true, get: function () { return math_1.PHI; } });
Object.defineProperty(exports, "PI2", { enumerable: true, get: function () { return math_1.PI2; } });
Object.defineProperty(exports, "log", { enumerable: true, get: function () { return math_1.log; } });
Object.defineProperty(exports, "mod", { enumerable: true, get: function () { return math_1.mod; } });
//# sourceMappingURL=index.js.map